import React from 'react';
import type { TimeCardShift } from '../../../../../js/api';
import { Dialog, DialogBody, DialogCloseButton, DialogTitle } from '../../../components/dialog';
import { DocumentsTab } from '../../../components/documents-tab';
import { formatDateTimeRange } from '../../../utils/date';

const CONTEXT_TYPE = 'assignments.timecardshift';

export const ShiftDocumentsModal: React.FC<{
  open: boolean;
  onClose: () => void;
  shift?: TimeCardShift;
  ownerId?: string;
  relatedProviderId?: string;
}> = ({ open, onClose, shift, ownerId, relatedProviderId }) => {
  if (!shift) return null;

  return (
    <Dialog open={open} onClose={onClose} size="2xl">
      <div className="tw:flex tw:items-start tw:justify-between">
        <DialogTitle>
          <>
            Shift Documents
            <div className="tw:text-xs tw:text-zinc-500 tw:font-normal">
              {formatDateTimeRange(shift)}
            </div>
          </>
        </DialogTitle>
        <DialogCloseButton onClick={onClose} />
      </div>
      <DialogBody>
        <DocumentsTab
          contextType={CONTEXT_TYPE}
          contextId={shift.id}
          ownerId={ownerId || ''}
          relatedProviderId={relatedProviderId}
        />
      </DialogBody>
    </Dialog>
  );
};
